import { BookingStatus } from '@massilia/prisma-generated/enums';
import { z } from 'zod';
import { isoDateString } from '../_shared/dates.js';
import { withRenamedDeprecatedKey } from '../_shared/deprecated-key.js';
// `installmentPaymentDeadline` est l'ancien nom de `paymentDeadline` : alias déprécié,
// à supprimer à la release suivante.
export const updateBookingConditionsSchema = withRenamedDeprecatedKey(z.object({
    depositDeadline: isoDateString().optional(),
    exchangeAllowed: z.boolean().optional(),
    exchangeFeeDescription: z.string().optional(),
    installmentChosen: z.boolean().optional(),
    installmentMinimumDepositAmount: z.coerce.number().nullish(),
    paymentDeadline: isoDateString().optional(),
    refundAllowed: z.boolean().optional(),
    refundFeeDescription: z.string().optional(),
}), 'installmentPaymentDeadline', 'paymentDeadline');
export const updateBookingStatusSchema = z.object({
    status: z.nativeEnum(BookingStatus),
});
export const updateBookingInsurancePriceSchema = z.object({
    price: z.number().min(0),
});
export const createBookingExtraSchema = z.object({
    bookingId: z.string().min(1),
    fileId: z.string().optional(),
    fileName: z.string().optional(),
    name: z.string().min(1),
    providerName: z.string().min(1),
    description: z.string().optional(),
    fileType: z.string().optional(),
    // Coût prestataire, requis à la création : sans lui la prestation entre dans
    // le dossier avec une marge inconnue, et rien ne rappellera plus de la
    // renseigner. Les prestations antérieures au suivi restent à NULL en base —
    // c'est le seul cas d'absence qu'on accepte.
    netAmountCents: z.number().min(0),
    price: z.number().min(0),
    providerExternalRef: z.string().min(1),
});
export const updateBookingExtraSchema = z.object({
    fileId: z.string().optional(),
    fileName: z.string().optional(),
    name: z.string().optional(),
    providerName: z.string().optional(),
    description: z.string().nullish(),
    fileType: z.string().optional(),
    // Optionnel comme tous les champs de ce PATCH partiel, mais jamais annulable :
    // pas de `nullish()`. Un net effacé rendrait une marge déjà mesurée à
    // l'inconnu, ce que le formulaire n'a aucune raison de demander.
    netAmountCents: z.number().min(0).optional(),
    price: z.number().min(0).optional(),
    providerExternalRef: z.string().optional(),
});
